<template>
  <!-- <div class="product"> -->
<!--
    <div class="productBox" v-for="(item, index) in productList" :key="index">

      <img :src="item.image" alt="" @click="toProductDetail(item)" />
      <p class="productName">{{ item.storeName }}</p>

      <div class="price">
        <span class="presentPrice">¥{{ item.price }}</span>
        <span class="originalPrice">¥{{ item.otPrice }}</span>
      </div>
      <div class="line"></div>
      <p class="productDesc" v-if="$route.name=='store' || $route.name=='search'">{{ item.productBrief }}</p>
      <p class="shopName" v-if="$route.name=='category'" @click.stop="toStore(item.shopId)"><span></span>{{ item.shopName?item.shopName:'测试店铺' }}</p>
    </div> -->

  <div>
    <div class="shopitem" v-if="productList">
      <div @click="toProductDetail(item)" class="likeProItem" v-for="item of productList" :key="item.id">
        <div class="main_shop1">
          <div class="main_shop1_ite">
            <img :src="item.image"  @click="toProductDetail(item)" alt="">
          </div>
          <div>
            <dl class="prop-item clearfix prop-service">
            </dl>
            <div class="main_datail" :title="item.storeName">{{item.storeName}}</div>
            <p class="main_price"><span>¥</span>{{item.price}}<span></span> </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: ['productList'],
  data  () {
    return {}
  },
  methods: {
    ...mapMutations({
      setCurrentPro: 'SET_CURRENTPRO'
    }),

    toProductDetail (item) {
      console.log(item)
      this.setCurrentPro(item)
      if (item.storeCode) {
        let routeData = this.$router.resolve({path: '/productDetail', query: {productId: item.storeCode.toString().trim()}})
        window.open(routeData.href, '_blank')
      } else {
        let routeData = this.$router.resolve({path: '/productDetail', query: {productId: item.storeCode}})
        window.open(routeData.href, '_blank')
      }
      // this.$router.push({path: '/productDetail' ,query:{productId:item.storeCode.toString().trim()}})
    },
    // 跳转到店铺
    toStore (id) {
      this.$router.push({
        path: '/store',
        query: {
            shopData: {shopId: id}
        }
      })
    }
  }
}
</script>
<style lang = "scss" scoped>

.product {
  width: 100%;
  display: flex;
  flex-flow: wrap;
  margin-bottom: 30px;
  .productBox {
    width: 282px;
    margin-bottom: 50px;
    margin-right: 11px;
    transition: all 0.3s linear;
    cursor: pointer;
    img {
      width: 282px;
      height: 282px;
      margin-bottom: 27px;
    }
    .productName {
      font-weight: bold;
      margin-bottom: 12px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
    }
    .price {
      margin-bottom: 12px;
      .presentPrice {
        font-size: 18px;
        font-weight: bold;
        color: #D22929;
      }
      .originalPrice {
        font-size: 16px;
        text-decoration: line-through;
        margin-left: 10px;
      }
    }
    .line {
      width: 160px;
      height: 2px;
      background-color: #f0f0f0;
      margin: 0 auto;
    }
    .productDesc,.shopName {
      margin-top: 20px;
      color: #999999;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
      span{
        width: 16px;
        height: 14px;
        margin-right: 5px;
        background-image: url('../../../static/image/dainpu@2x.png');
      }
    }
    .shopName{
      cursor: pointer;
    }
  }
  .productBox:nth-of-type(4n){
    margin-right: 0;
  }
  .productBox:hover{
    box-shadow:0 0 20px #cccccc;
  }
}

  .shopitem{
    display: flex;
  }
  .shopitem{
    flex-wrap: wrap;
  }
    .shopitem{
    margin-top: 10px;
  }
 .likeProItem{
    padding: 15px 10px;
    background-color: white;
  }

 .main_shop1{
    margin-top: 0;
    background-color: #fffffF;
    padding: 15px 0px;
    border: 1px solid #eeeeee;
  }
 .main_shop1:hover{
   transform: scale(1.05);
   // justify-content: space-around;
   //box-shadow: 2px 2px 1px #D9D9D9;
   border: 1px solid #D22929;
 }
  .caidan{
    margin-left: 0;
  }
  .main_shop1_ite:hover{
    transform: scale(1.0);
  }

  .main_shop1_ite{
        width: 190px;
        height: 190px;
        margin: 0 auto;
		 transition: transform 0.6s;
         overflow: hidden;
				 cursor: pointer;
    }
    .main_shop1_ite img{
        width: 100%;
    }
    .shopitem{
      flex-wrap: wrap;
    }
    .main_shop1{
        width: 230px;
        height: 320px;
        /* border: 1px solid red; */
       /* // margin-top: 11px; */
        /* // padding: 17px 20px 0 20px; */
        padding-left: 0%;

    }

      .main_shop1_ite img{
        width: 100%;
	      transition: transform 1.6s;
        margin-top: 0;
    }

        .main_datail{

        font-family: Microsoft YaHei;
        margin-top: 20px;
        margin-bottom: 15px;
        font-weight: 400;
        width: 176px;
        height: 45px;
        line-height: 24px;
        margin-left: 28px;
        font-size: 16px;
        color: #666666;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .main_price span{
        line-height: 12px;
        font-size: 8px;
        font-weight: normal;
    }
.main_price{
  font-size: 14px;
  font-weight: bold;
  color: #D22929;
  margin-left: 28px;
  /* display: flex; */
  /* align-items: flex-end;  */
  line-height: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/base/productList.vue